<template>
  <box-model title="加工阶段概况">
    <template v-slot:content>
      <div class="select-part">
        <select-box :sty="false" :list="selList" :item="selItem" @sel="selEvent"></select-box>
      </div>
      <div class="container">
        <div class="pie-sty">
          <div id="jgechart" class="con"></div>
          <div class="show-part flex-y-center">
            <div class="sm">
              <div class="s-title">{{ selItem.value }}<span style="font-size: 14px;line-height: 14px;font-weight: 400;margin-left: 6px;">年</span></div>
            </div>
          </div>
        </div>
        <div class="line-sty">
          <div class="column-sty flex-between">
            <div class="item">
              <div class="it">加工中</div>
              <div class="ic flex-x-center">
                <img class="ic-img " src="../../assets/img/jia-gong-zhong.png" />
                <span class="txt">{{ detail.inProcessingNum || 0 }}<span class="t">件</span></span>
              </div>
            </div>
            <div class="item">
              <div class="it">加工完成</div>
              <div class="ic flex-x-center">
                <img class="ic-img " src="../../assets/img/jia-gong-done.png" />
                <span class="txt">{{ detail.processingCompletionNum || 0 }}<span class="t">件</span></span>
              </div>
            </div>
            <div class="item">
              <div class="it">质检完成</div>
              <div class="ic flex-x-center">
                <img class="ic-img " src="../../assets/img/zhi-jian-done.png" />
                <span class="txt">{{ detail.inspected || 0 }}<span class="t">件</span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </box-model>
</template>
<script>
  import echarts from 'echarts'
  import { getProcessRecordStage } from "@/api/index";
  export default {
    data() {
      return {
        selList: [],
        selItem: {},
        detail: {}

      }
    }, 
    components: {
      "box-model": () => import("../../components/common/Model.vue"),
      "select-box": () => import("../../components/common/SelectBox.vue")
    },
    mounted(){
      this.getYearFn();
    },
    methods: {
      // 年份获取
      getYearFn(){
        const curYear = new Date().getFullYear();
        this.selList = [
          {name: `${curYear}年`, value: curYear},
          {name: `${curYear - 1}年`, value: curYear-1},
          {name: `${curYear - 2}年`, value: curYear-2}
        ];
        this.selItem = this.selList[0];
        this.getProcessRecordStageFn();
      },
      selEvent(item) {
        this.selItem = item;
        this.getProcessRecordStageFn();
      },
      
      init(option) {
        const myChart = echarts.init(document.getElementById("jgechart"));
        myChart.setOption(option);
      },
      getProcessRecordStageFn() {
        getProcessRecordStage({
          year: this.selItem.value
        }).then((res) => {
          const result = res.data || {};
          this.detail = result;
          const option = {
            tooltip : {
              trigger: 'item',
              formatter: function(item){
                let result = `
                  <div style="padding: 12px;z-index:1001;position: relative;">
                    <div style="color: #3E3E3E;font-size: 16px;">${item.name}</div>
                    <div style="width: 100%;height: 1px;background: #E8E8EA;margin:8px 0; "></div>
                    <div style="display: flex;align-items: center;">
                      <div style="width: 8px;height: 8px;background: ${item.color};border-radius: 50%;"></div>
                      <div style="color: #000E2B;font-size: 16px;margin-left: 4px;line-height: 16px;">数量：${item.value}</div>  
                    </div>
                  </div>
                `;
                return result;
              },
              backgroundColor: '#fff',
            },
            color:['#FF6637','#FFCC00','rgb(6,247,161)'],
            series: [
              {
                name: '资源总量构成',
                type: 'pie',
                center: ['50%', '50%'],
                radius: ['50%', '66%'],
                data:[
                  {value: result.inProcessingNum || 0, name:'加工中', color: '#FF6637'},
                  {value: result.processingCompletionNum || 0, name:'加工完成', color: '#FFCC00'},
                  {value: result.inspected || 0, name:'质检完成', color: 'rgb(6,247,161)'},
                ],
                itemStyle: {
                  emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                },
                itemStyle: {
                  normal: {
                    label:{ 
                      show: true, 
                      formatter: function(param) {
                        return `${param.name}：${param.percent}%`
                      },
                      fontSize : 16,
                    }
                  },
                  labelLine :{show:true}
                }
              }
            ]
          };
          this.init(option);
        })
      }
    }
  }
</script>
<style scoped lang="less">
  .select-part {
    position: absolute;
    top: -10px;
    right: 10px;
    width: 100px;
    font-size: 14px;
    font-weight: 400;
  }
  .container {
    position: relative;
    width: 100%;
    height: 438px;
    .pie-sty {
      position: relative;
      width: 100%;
      height: 200px;
      .con {
        position: relative;
        z-index: 0;
        width: 100%;
        height: 200px;
      }
      .show-part {
        position: absolute;
        z-index: 999;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 40%;
        height: 40%;
        .sm {
          width: 100%;
          .s-title {
            font-size: 24px;
            font-weight: 700;
            color: rgba(255,255,255,1);
            line-height: 24px;
            text-align: center;
          }
      }
      }
    }
    .line-sty {
      position: relative;
      width: 100%;
      height: 238px;
      padding-top: 20px;
      .column-sty {
        width: 100%;
        height: 160px;
        padding-top: 10px;
        .item {
          width: 108px;
          height: 100%;
          padding-top: 20px;
          .it {
            font-size: 18px;
            font-weight: 400;
            color: rgba(255,255,255,0.8);
            line-height: 18px;
            text-align: center;
          }
          .ic {
            position: relative;
            width: 100%;
            height: 100px;
            margin-top: 14px;
            padding-top: 10px;
            .ic-img {
              position: absolute;
              top: 0;
              left: 0;
              z-index: 0;
              width: 100%;
              height: 100%;
            }
            .txt {
              position: relative;
              z-index: 3;
              font-size: 26px;
              font-weight: 700;
              color: #FFFFFF;
              line-height: 26px;
              text-align: center;
              .t {
                font-size: 18px;
                font-weight: 400;
                color: #FFFFFF;
                margin-left: 8px;
              }
            }
          }
        }
      }
    }
  }
</style>